import React, { SyntheticEvent, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { authApi } from "../../api";
import { LangSwitcher } from "../../components/LangSwitcher/LangSwitcher";
import onb1 from "../../assets/onbpics/1.jpg";
import onb3 from "../../assets/onbpics/3.jpg";
import onb5 from "../../assets/onbpics/5.jpg";
import onb6 from "../../assets/onbpics/6.jpg";
import marginLogo from "../../assets/vectorlogo.png";
import { buildWhatsappUrl } from "../Landing/utm";
import "./index.css";

const PICS = [onb1, onb3, onb5, onb6];

const MANAGER_PHONE = "77079201320";

const Login = () => {
  const { t } = useTranslation("login");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState(false);
  const navigate = useNavigate();

  const pic = useMemo(() => PICS[Math.floor(Math.random() * PICS.length)], []);

  const handleSubmit = async (event: SyntheticEvent) => {
    event.preventDefault();
    setLoading(true);
    setLoginError(false);
    try {
      const { data } = await authApi.login(username, password);
      localStorage.setItem("token", data.token);
      navigate("/forms");
    } catch (error) {
      console.error("Login failed:", error);
      setLoginError(true);
    }
    setLoading(false);
  };

  return (
    <div className="ml-login">
      <div
        className="ml-login__bg"
        style={{ backgroundImage: `url(${pic})` }}
      />
      <div className="ml-login__bg-overlay" />

      <div className="ml-login__card">
        <div className="ml-login__photo-wrap">
          <div
            className="ml-login__photo"
            style={{ backgroundImage: `url(${pic})` }}
          />
        </div>

        <div className="ml-login__form-side">
          <div className="ml-login__brand">
            <img src={marginLogo} alt="lovestoria" className="ml-login__brand-img" />
            <div className="ml-login__brand-lang">
              <LangSwitcher tone="dark" />
            </div>
          </div>

          <div className="ml-login__heading">
            <div className="ml-login__kicker">{t("kicker")}</div>
            <h1 className="ml-login__title">{t("title")}</h1>
          </div>

          <form className="ml-login__form" onSubmit={handleSubmit}>
            <div className="ml-login__field">
              <label className="ml-login__label" htmlFor="username">
                {t("username_label")}
              </label>
              <input
                type="text"
                id="username"
                name="username"
                className="ml-login__input"
                placeholder={t("username_placeholder") as string}
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                autoComplete="username"
              />
            </div>

            <div className="ml-login__field">
              <label className="ml-login__label" htmlFor="password">
                {t("password_label")}
              </label>
              <input
                type="password"
                id="password"
                name="password"
                className="ml-login__input"
                placeholder={t("password_placeholder") as string}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
              />
            </div>

            {loginError && (
              <div className="ml-login__error">{t("error")}</div>
            )}

            <button
              className="ml-login__submit"
              type="submit"
              disabled={isLoading}
            >
              {isLoading ? t("submitting") : t("submit")}
            </button>
          </form>

          <div className="ml-login__manager">
            {t("no_account")}{" "}
            <a
              href={buildWhatsappUrl(MANAGER_PHONE)}
              target="_blank"
              rel="noopener noreferrer"
              className="ml-login__manager-link"
            >
              {t("contact_manager")}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
